/* ==========================================================================
 * aef-countup.js — shared count-up animation for REDESIGN stat displays.
 * Loaded via <script src> (theme-agnostic: works even where {% javascript %}
 * section bundling doesn't run). Scans any [data-countup] element:
 *   data-countup="32895"  data-decimals="2"  data-suffix=" ★"
 * Animates on scroll into view; reduced-motion snaps instantly. Idempotent.
 * ========================================================================== */
(function(){
  'use strict';
  if (window.__aefCountUpInit) return;
  window.__aefCountUpInit = true;

  /* 🔴 25/9/2026 — PHẢI truyền 'en-US'. Máy chủ (sections/aef-stat-bar.liquid)
     tự tách nghìn bằng dấu phẩy: "37,106" · "2,600+". toLocaleString() trần ăn
     theo ngôn ngữ MẶC ĐỊNH của trình duyệt ⇒ máy tiếng Việt đếm xong ra
     "37.106", máy Pháp "37 106", máy Ả Rập "٣٧٬١٠٦" — kể cả khi khách bấm EN.
     Một con số thì một quy ước. Người gác: scripts/test-dem-so-uy-tin-khop-chu-may-chu.js */
  function fmt(n, dec){
    return dec ? Number(n).toFixed(dec) : Math.round(n).toLocaleString('en-US');
  }
  function run(el){
    if (el.getAttribute('data-cu-done') === '1') return;
    el.setAttribute('data-cu-done', '1');
    var target = parseFloat(el.getAttribute('data-countup'));
    if (isNaN(target)) return;
    var dec = parseInt(el.getAttribute('data-decimals'), 10) || 0;
    var suf = el.getAttribute('data-suffix') || '';
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce){ el.textContent = fmt(target, dec) + suf; return; }
    var t0 = null, dur = 1500;
    function step(t){
      if (!t0) t0 = t;
      var k = Math.min((t - t0) / dur, 1);
      k = 1 - Math.pow(1 - k, 3);
      el.textContent = fmt(target * k, dec) + suf;
      if (k < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  /* 🔴 24/8/2026 — MÁY CHỦ NAY IN RA SỐ THẬT, JS CHỈ LÀM HIỆU ỨNG.
     Trước đây HTML in cứng `0` và file này đếm lên. Tắt JS là dải "uy tín" nói
     tiệm đã giao 0 đơn — nên markup đã đổi để in số thật ngay từ máy chủ.

     Hệ quả cho file này: KHÔNG được vô tư hạ về 0 rồi đếm lên nữa, vì bây giờ
     cú hạ đó là một con số SAI hiện ra trước mắt khách. Chỉ hạ về 0 khi phần
     tử còn NẰM NGOÀI khung nhìn — lúc đó không ai thấy cú hạ, và tới khi cuộn
     tới thì hiệu ứng chạy đủ. Phần tử đã nằm trong tầm mắt ngay lúc tải thì
     giữ nguyên số thật, không hiệu ứng: đằng nào khách cũng đã đọc xong nó
     trước khi hiệu ứng kịp chạy.

     Dùng getBoundingClientRect chứ không đợi lần gọi lại đầu tiên của
     IntersectionObserver: với `threshold: 0.4` một phần tử ĐANG hiện một nửa
     vẫn bị báo là "không giao nhau", và mình sẽ hạ nó về 0 ngay trước mắt khách. */
  function trongTam(el){
    var r = el.getBoundingClientRect();
    var cao = window.innerHeight || document.documentElement.clientHeight;
    return r.bottom > 0 && r.top < cao;
  }
  function veKhong(el){
    var dec = parseInt(el.getAttribute('data-decimals'), 10) || 0;
    el.textContent = fmt(0, dec) + (el.getAttribute('data-suffix') || '');
  }
  function init(){
    var els = document.querySelectorAll('[data-countup]');
    if (!els.length) return;
    /* Không có IntersectionObserver: giữ nguyên số máy chủ đã in. Trước đây
       nhánh này chạy `run()` cho tất cả, tức đếm lên ngay cả khi phần tử còn
       ở tận cuối trang — hiệu ứng chạy xong trước khi ai nhìn thấy. */
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if (e.isIntersecting){ run(e.target); io.unobserve(e.target); } });
    }, { threshold: 0.4 });
    Array.prototype.forEach.call(els, function(el){
      if (trongTam(el)) { el.setAttribute('data-cu-done', '1'); return; }
      veKhong(el);
      io.observe(el);
    });
  }
  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
